import axios from 'axios';

/**
 * helper utility function
 *
 */
export async function fetchData<ExpectedResponseType>(
  url: string,
  method: 'GET' | 'POST' | 'DELETE' | 'PUT',
  data?: any,
  params?: any
) {
  const tokenFromUrl = new URLSearchParams(location.search);

  const enhancedUrl = tokenFromUrl.has('token')
    ? `${url}?token=${tokenFromUrl.get('token')}`
    : url;

  try {
    const response = await axios<ExpectedResponseType>({
      url: enhancedUrl,
      method,
      data,
      params,
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch data from ${enhancedUrl}:`, error);
  }
}
